import React from 'react';
import VatEdit from './VATAdd';

const VATEdit = () => {
  return <VatEdit />;
};

export default VATEdit;
